module.exports = __webpack_public_path__ + "img/icono_send.badcf586.svg";